<!-- @veltra/icons generated sha256:9bbc0525acb49069 gen:8 source:src/svg/normal/build.svg -->
<script setup lang="ts">
defineOptions({ name: 'Build' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9M18 15l4-4" />
    <path
      d="m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5"
    />
  </svg>
</template>
